module.exports = __webpack_public_path__ + "f2cff76c98857e71cf87e07fe66554f0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/flask-blue.png
// module id = 2838
// module chunks = 0